import { useCallback, useEffect } from 'react'
import { OpenAPI, SurveyEngine_Models_SEPostSurveyScheduleOperation, SurveyService_Application_Commands_SubmitCalendarSchedule_CalendarURLs } from '../api'
import { SurveyApiService } from '../api/services/SurveyApiService'
import { ScheduleState } from '../Common'
import { useSurveyCtxDispatch } from '../Context/SurveyContext'
import { useGlobalCtx } from '../Context/GlobalContext'
import { useRecruitDispatchCtx } from '../Context/RecruitContext'
import { useThemeKeyValues } from './useThemeKeyValues'


export function usePostSurvey(studyId: number, panelistId: number) {

  // const surveyCtx = useSurveyCtx()
  const surveyCtxDispatch = useSurveyCtxDispatch()
  const globalCtx = useGlobalCtx()
  const recruitCtxDispatch = useRecruitDispatchCtx()
  //const { getThemeKeyValueCommand } = useThemeKeyValues();

  const getSubmitSchedule = useCallback((panelistId:number,StudyId:number,operationType:SurveyEngine_Models_SEPostSurveyScheduleOperation,payload:Array<number>) => {
    if (panelistId && StudyId && StudyId > 0 && panelistId > 0)  {
      surveyCtxDispatch({type:"setLoading",value:true});
      SurveyApiService.postV1SurveySubmitSchedule(panelistId,studyId,operationType,payload)
      .then((data) => {
        if(data.success)
        {
          if(globalCtx.App === "portal")
          {
            //window.open(globalCtx.RedirectUrl, '_parent')
            window.location.href = globalCtx.RedirectUrl;
          }
          else
          {
            surveyCtxDispatch({type:"setComplete",value:true});
            surveyCtxDispatch({type:"setLoading",value:false});
          }
        }
        else
        {
          throw data
        }
               
      }).catch((e: any) => {
        console.log("Failed to submit schedule" + e);
        surveyCtxDispatch({type:"SetAPIError",value:e});
        recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_RESCHEDULE });
        surveyCtxDispatch({type:"setLoading",value:false});
      });
    }
  }, [globalCtx.App, globalCtx.RedirectUrl, studyId, surveyCtxDispatch,recruitCtxDispatch]);

  const getSubmitCalendarSchedule = useCallback((panelistId:number,StudyId:number,payload:SurveyService_Application_Commands_SubmitCalendarSchedule_CalendarURLs) => {
    if (panelistId && StudyId && StudyId > 0 && panelistId > 0 && payload.eventURL && payload.inviteeURL)  {
      surveyCtxDispatch({type:"setLoading",value:true});
      SurveyApiService.postV1SurveySubmitCalendarSchedule(panelistId,studyId,payload)
      .then((data) => {
        if(data.success)
        {
          if(globalCtx.App === "portal")
          {
            //window.open(globalCtx.RedirectUrl, '_parent')
            window.location.href = globalCtx.RedirectUrl;
          }
          else
          {
            surveyCtxDispatch({type:"setComplete",value:true});
            surveyCtxDispatch({type:"setLoading",value:false});
          }
        }
        else
        {
          throw data
        }
               
      }).catch((e: any) => {
        console.log("Failed to submit calendar schedule" + e);
        surveyCtxDispatch({type:"SetAPIError",value:e});
        surveyCtxDispatch({type:"setLoading",value:false});
      });
    }
  }, [globalCtx.App, globalCtx.RedirectUrl,studyId,surveyCtxDispatch]);
  const getPanelistScheduledSessions = useCallback((panelistId:number,StudyId:number) => {
    if (panelistId && StudyId && StudyId > 0 && panelistId > 0)  {
      surveyCtxDispatch({type:"setLoading",value:true});
      SurveyApiService.getV1SurveyPanelistScheduledSessions(panelistId,studyId)
      .then((data) => {
        if(data.success)
        {
          surveyCtxDispatch({type:"currentSchedule",value:data.schedule});
          surveyCtxDispatch({type:"timeZone",value:data.schedule?.panelistTimeZone && data.schedule.panelistTimeZone.length > 0 ?
                                                                data.schedule.panelistTimeZone:
                                                                Intl.DateTimeFormat().resolvedOptions().timeZone});
          globalCtx.RedirectUrl !== ""? surveyCtxDispatch({type:"RedirectURL",value:globalCtx.RedirectUrl}):  surveyCtxDispatch({type:"RedirectURL",value:globalCtx.DomainName});
          if(data.schedule?.panelistOverAllStatus === "ScheduledNotConfirmed")
          {
            recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_CONFIRM });
          }
          else if(data.schedule?.panelistOverAllStatus === "PartiallyScheduled" ||
            data.schedule?.panelistOverAllStatus === "Scheduled" ||
            data.schedule?.panelistOverAllStatus === "Standby")
          {
            recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_SCHEDULED });
          }
          else if(data.schedule?.panelistOverAllStatus === "Cancelled")
          {
            recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_CANCELLED });
          }
          else if(data.schedule?.panelistOverAllStatus === "CompletedDialog")
          {
            recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_COMPLETED_DIALOG });
          }
          recruitCtxDispatch({ type: "PanelistStatus", value: data.schedule?.panelistOverAllStatus ?? "Unknown" });
          surveyCtxDispatch({type:"clearAPIError",value:{}});

        }
        else
        {
          throw data
        }
               
      }).catch((e: any) => {
        console.log("Failed to get Panelist Current schedule :" + e);
        surveyCtxDispatch({type:"SetAPIError",value:e});
      }).finally(()=>{
        surveyCtxDispatch({type:"setLoading",value:false});
      });
    }
  }, [globalCtx.DomainName, globalCtx.RedirectUrl, recruitCtxDispatch, studyId, surveyCtxDispatch]);

  const getPanelistAvailableSessions = useCallback((panelistId:number,StudyId:number,PanelistStatus:string) => {
    if (panelistId && StudyId && StudyId > 0 && panelistId > 0)  {
      surveyCtxDispatch({type:"setLoading",value:true});
      SurveyApiService.getV1SurveyPanelistAvailableSessions(panelistId,studyId,0)
      .then((data) => {
        if(data.success)
        {
          surveyCtxDispatch({type:"availableSessions",value:data.sessions});
          surveyCtxDispatch({type:"timeZone",value:data.panelistTimeZone && data.panelistTimeZone.length > 0 ?
                                              data.panelistTimeZone:
                                              Intl.DateTimeFormat().resolvedOptions().timeZone});
          globalCtx.RedirectUrl !== ""? surveyCtxDispatch({type:"RedirectURL",value:globalCtx.RedirectUrl}):  surveyCtxDispatch({type:"RedirectURL",value:globalCtx.DomainName});
          surveyCtxDispatch({type:"setLoading",value:false}); 
        }
        else
        {
          throw data
        }
               
      }).catch((e: any) => {
        console.log("Failed to get Panelist Current Available Session: " + e);
        surveyCtxDispatch({type:"SetAPIError",value:e});
        if(PanelistStatus === "ScheduledNotConfirmed")
        {
          recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_CONFIRM });
          surveyCtxDispatch({type:"setLoading",value:false});
        }
        else if(PanelistStatus === "PartiallyScheduled" ||
        PanelistStatus === "Scheduled" ||
        PanelistStatus === "Standby")
        {
          recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_SCHEDULED });
          surveyCtxDispatch({type:"setLoading",value:false});
        }
      });
    }
  }, [globalCtx.DomainName, globalCtx.RedirectUrl, studyId,recruitCtxDispatch, surveyCtxDispatch]);

  const getRefreshToken = useCallback((studyID:number,panelistID:number,postSurvey:boolean) => {
    if(studyID > 0  && panelistID > 0) 
    {
      SurveyApiService.postV1SurveyRefreshToken(studyID,panelistID,postSurvey)
      .then((data) => {
        if(data?.token)
        {
          OpenAPI.TOKEN = data.token
          console.log("refresh token success")
        }          
        else
          console.log("failed to refresh token")
      }).catch((e: any) => {
        console.log("Failed refresh token" + e);
      });
    }
    
  }, []);

  const getAbandonSurvey = useCallback((surveySID:string) => {
    if (surveySID) {
      SurveyApiService.postV1SurveyAbandon(
        surveySID
      ).then((data) => {
        if(!data?.success)
        {
          console.log("Failed to Abandon Survey: "+ data.msg)
        }          
      }).catch((e: any) => {
        console.log("Failed Abandon Survey" + e);
      });
    }
  }, []);

  useEffect(() => {
    //getThemeKeyValueCommand(globalCtx.Theme,globalCtx.Language);
    getPanelistScheduledSessions(panelistId,studyId);
    
  }, [studyId, panelistId, getPanelistScheduledSessions,globalCtx.Theme,globalCtx.Language]);

  return {getRefreshToken,getPanelistAvailableSessions,getPanelistScheduledSessions,getSubmitSchedule,getSubmitCalendarSchedule,getAbandonSurvey};
 
}

